import { combineReducers } from 'redux'

import booking from './booking'
import page from './page'
import transaction from './transaction'
import user from './user'
import website from './website'

export default combineReducers({
  booking,
  page,
  transaction,
  user,
  website
})
